export default __webpack_public_path__ + "static/media/hungo-screenshot-01.ae7bce40.png";